
<template>
  <div>
    <v-row>
      <v-col cols="12" lg="6" v-if="department">
        <v-text-field v-if="department" label="Selcione o departamento" v-model="department" readonly class="px-5"></v-text-field>
      </v-col>
      <v-col cols="12" :lg="!department ? 12 : 6" class="d-flex justify-center align-center">
        <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable width="800px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark v-on="on" @click="getDepartments">selecionar departamento</v-btn>
          </template>
          <v-card v-if="dialog">
            <v-card-title primary-title class="pa-0">
              <v-toolbar dark color="primary" >
                <v-toolbar-title>Departamentos</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="dialog = false" dark>
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
            </v-card-title>
            <v-card-text>
              <v-alert v-if="loading_depts" type="info" :value="true">
                Carregando... 
                <v-progress-linear color='white' :indeterminate="true"></v-progress-linear>
              </v-alert>
              <v-treeview
                v-if="!loading_depts && all_departments"
                return-object
                hoverable 
                shaped 
                activatable 
                :items="all_departments"
                :open.sync="open"
                :active.sync="active"
                :active-class="'grey lighten-3 font-weight-bold'"
                ref="treeDepto"
                dense
              >
              </v-treeview>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn v-if="!create_user" color="success" @click="saveDepartment()">Salvar</v-btn>
              <v-btn v-if="create_user" color="success" @click="createUserDepartment()">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-col>
    </v-row>
    <!-- <v-select
    v-if="all_departments"
      :items="all_departments"
      item-text="name"
      item-value="id"
      v-model="department"
      label="Selecione o departamento"
      :rules="required"
    ></v-select> -->
    
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import validations from '@/mixins/validations';

export default {
  name: 'NewExecutionDepartment',
  props: {
    create_user: {
      type: Boolean,
      default: false
    },
  },
  mixins: [ validations ],
  data() {
    return {
      department: null,
      loading: false,
      dialog: false,
      loading_depts: false,
      active: [],
      open: [1]
    }
  },
  mounted () {
    
  },
  methods: {
    createUserDepartment() {
      this.$emit('saveDepartment', this.active[0]);
      this.dialog = false;
    },
    saveDepartment() {
      if (this.active[0]) {
        this.updateExecDepId(this.active[0].id);
        this.department = this.active[0].name;
        this.dialog = false;
      }
    },
    getDepartments() {
      this.loading_depts = true;
      this.indexDepartments().then(() => {
        this.loading_depts = false;
      })
    },
    ...mapActions({
      indexDepartments: 'Department/index',
      updateExecDepId: 'Execution/updateExecDepId'
    })
  },
  computed: {
    ...mapState({
      all_departments: state => state.Department.all_departments,
      department_id: state => state.Execution.department_id
    })
  },
  watch: {
    
  },
}
</script>

<style scoped>

</style>